import React, { forwardRef } from "react"
import DatePicker, { CalendarContainer } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";


const years = _.range(2000, (new Date()).getFullYear() + 3, 1)
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]

const CustomDateTimeSelect = ({
  date,
  changeYear,
  changeMonth,
}) => (
  <div className="custom-calendar-header">
    <select
      value={months[date.getMonth()]}
      onChange={({ target: { value } }) => changeMonth(months.indexOf(value))
      }>
      {months.map(option => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>

    <select
      value={date.getFullYear()}
      onChange={({ target: { value } }) => changeYear(value)}>
      {years.map(option => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
)

const CustomSimpleDatePicker = ({ requesting, ...props }) => {
  const MyContainer = ({ className, children }) => (
    <div className="ca-custom">
      <CalendarContainer className={className}>
        {children}
      </CalendarContainer>
    </div>
  )

  const SimpleCustomInput = forwardRef(({ value, onClick }, ref) => {
    if (requesting) {
      return <div ref={ref}>Updating</div>
    }
    return (
      <button ref={ref} type="button" className="btn btn-block dropdown-toggle" onClick={onClick}>
        {value}
      </button>
    )
  })

  return (
    <DatePicker
      {...props}
      calendarContainer={MyContainer}
      customInput={<SimpleCustomInput />}
      renderCustomHeader={CustomDateTimeSelect} />
  )
}

export default CustomSimpleDatePicker